/* @typescript-eslint/no-unsafe-assignment */

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import AutoCreate, { ContentType } from 'common/components/AutoCreate';

import { KfaServiceHttpClient } from 'common/services/httpClient';

import styles from 'common/components/AutoCreate/AutoCreate.module.scss';
import { resetHypothesis } from '../hypothesisSlice';

type Params = {
  projectId: string;
};

export default () => {
  const { projectId } = useParams<Params>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetHypothesis());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AutoCreate
      contentType={ContentType.KeyFocusArea}
      createApiEndpointUrl={`/projects/${projectId}/KeyFocusAreas/create`}
      makeEditUrl={(kfaId) =>
        `/projects/${projectId}/key-focus-areas/${kfaId}/edit`
      }
      httpClient={KfaServiceHttpClient}
      errorClasses={styles['error-wrapper']}
      loaderClasses={styles['loader-wrapper']}
    />
  );
};
